module.exports = __webpack_public_path__ + "img/login.43ac844c.svg";